import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';
import { useUserData } from '../hooks/useUserData';
import { PageLoader, Spinner } from '../components/common/Loader';
import NetworkGuard from '../components/common/NetworkGuard';
import InvestForm from '../components/invest/InvestForm';
import MyMachines from '../components/invest/MyMachines';
import '../components/invest/Machines.css';

export default function InvestPage() {
  const { isConnected, connect, connecting } = useWallet();
  const { packages, balances, refresh, isRegistered, userId, loading } = useUserData();
  const navigate = useNavigate();
  const [tab, setTab] = useState('buy');

  if (!isConnected) {
    return (
      <div className="container invest-page">
        <div className="empty-state">
          <div className="icon">🔒</div>
          <h3 style={{ marginBottom: 8 }}>Connect Your Wallet</h3>
          <button className="btn btn-primary btn-lg mt-4" onClick={connect} disabled={connecting}>
            {connecting ? <><Spinner /> Connecting</> : 'Connect Wallet'}
          </button>
        </div>
      </div>
    );
  }

  const showRegisterGate = !loading && !isRegistered && userId === 0;

  return (
    <NetworkGuard>
      <div className="container invest-page">
        {showRegisterGate ? (
          <div className="empty-state">
            <div className="icon">📝</div>
            <h3 style={{ marginBottom: 8 }}>Please Register First</h3>
            <p style={{ marginBottom: 24 }}>Register your account to purchase mining machines.</p>
            <button className="btn btn-primary btn-lg" onClick={() => navigate('/register')}>
              Register Now →
            </button>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: 8 }}>
              <div className="section-eyebrow">XTERRA FORGE SERIES</div>
              <h1>
                {tab === 'buy' ? <>Purchase a <span className="text-gradient">Mining Machine</span></>
                              : <>My <span className="text-gradient">Mining Machines</span></>}
              </h1>
              <p style={{ color: 'var(--text-muted)', marginTop: 6 }}>
                {tab === 'buy'
                  ? 'Select an XTerra Forge machine. Each earns XT tokens daily until its mining cycles are exhausted.'
                  : 'Your active and past mining machines.'}
              </p>
            </div>

            <div className="invest-tabs" style={{ marginTop: 20 }}>
              <button
                className={`invest-tab ${tab === 'buy' ? 'active' : ''}`}
                onClick={() => setTab('buy')}
              >
                Purchase Machines
              </button>
              <button
                className={`invest-tab ${tab === 'mine' ? 'active' : ''}`}
                onClick={() => setTab('mine')}
              >
                My Machines {packages.length > 0 && `(${packages.length})`}
              </button>
            </div>

            {tab === 'buy' && (
              <InvestForm balances={balances} onDone={refresh} isRegistered={isRegistered} />
            )}
            {tab === 'mine' && (
              loading ? <PageLoader label="LOADING MACHINES" sub="Fetching your machines..." />
                      : <MyMachines packages={packages} />
            )}
          </>
        )}
      </div>
    </NetworkGuard>
  );
}
